import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import {
  form,
  FormField,
  validateStandardSchema,
} from '@angular/forms/signals';

import { RouterModule } from '@angular/router';
// 3rd party
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

// local
import { Card, FormErrorWrapper, FormLabel } from '@aurrica-web/ui';
import { injectDispatch } from '@ngrx/signals/events';
import {
  authEvents,
  PasswordResetRequest,
  PasswordResetRequestSchema,
} from '@aurrica-web/core-data';
import { AuthFormHeader } from '../layout/auth-form-header';

@Component({
  selector: 'lib-auth-password-reset-form',
  imports: [
    CommonModule,
    RouterModule,
    FormField,
    FontAwesomeModule,
    Card,
    FormLabel,
    FormErrorWrapper,
    AuthFormHeader,
  ],
  template: `
    <lib-ui-card class="bg-white dark:bg-background-dark shadow-md rounded-md">
      <lib-auth-form-header title="Reset Password" />
      <form
        (submit)="onSubmit($event)"
        novalidate
        class="p-4 grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-1 items-start"
      >
        <!-- Email -->
        <div class="flex flex-col gap-0.5 col-span-1 sm:col-span-2">
          <lib-ui-form-error
            [form]="resetForm"
            ctrlName="email"
            #emailError="formError"
          >
            <lib-ui-form-label label="Email" />
          </lib-ui-form-error>
          <input
            type="email"
            placeholder="you@example.com"
            class="form-control"
            [ngClass]="{
              'form-control-valid': !emailError.hasError,
              'form-control-error': emailError.hasError,
            }"
            [formField]="resetForm.email"
          />
        </div>

        <div
          class="flex flex-row justify-center gap-2 col-span-1 sm:col-span-2 mt-4"
        >
          <button
            type="submit"
            class="text-sm px-4 py-1 rounded-md
            bg-slate-950 text-white cursor-pointer
            dark:bg-white dark:text-slate-950
            hover:bg-slate-800 dark:hover:bg-slate-200
            "
            [disabled]="resetForm().invalid()"
          >
            Submit
          </button>
        </div>

        <p
          class="text-gray-800 dark:text-gray-400 text-xs fonr-medium text-center mt-6 col-span-1 sm:col-span-2"
        >
          <a
            routerLink="/login"
            class="text-blue-500 font-semibold hover:underline ml-1 whitespace-nowrap"
            >Sign In</a
          >
        </p>
      </form>
    </lib-ui-card>
  `,
})
export class PasswordResetForm {
  readonly dispatch = injectDispatch(authEvents);

  resetModel = signal<PasswordResetRequest>({ email: '' });
  resetForm = form(this.resetModel, (schemaPath) =>
    validateStandardSchema(schemaPath, PasswordResetRequestSchema),
  );

  onSubmit(event?: Event) {
    event?.preventDefault();
    if (this.resetForm().valid()) {
      const email = this.resetForm().value().email ?? '';
      this.dispatch.setConfirmationEmail(email);
      this.dispatch.resetPassword(email);
    } else {
      this.resetForm.email().markAsTouched();
    }
  }
}
